import moment from 'moment'
import React, {useEffect, useState} from 'react'
import {Tabs, Tab} from 'react-bootstrap'
import {useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {createEvent} from 'ics'
import YouTube, {YouTubeProps} from 'react-youtube'
import {saveAs} from 'file-saver'
import {useDispatch, useSelector} from 'react-redux'
import {
  getLandingPageDetail,
  getLandingPageData,
  responseLandingPageData,
} from './EndUserSlice/EndUserSlice'
import SuccessMessagePage from '../../../Components/SuccessMessagePage'

const LandingPage = () => {
  const param = useLocation()
  const landingpageDetail = useSelector(getLandingPageDetail)
  const [formValues, setFormValues] = useState<any[]>([])
  const [optionData, setOptionData] = useState<any>([])
  const [isSuccess, setIsSuccess] = useState(false)

  const dispatch = useDispatch()
  const [media, setMedia] = useState('media')
  const [rsvpButton, setRsvpButton] = useState(false)
  const [toggleHeader, setToggleHeader] = useState(true)
  const [toggleQuote, setToggleQuote] = useState([false])
  const [toggleBulletPoint, setToggleBulletPoint] = useState([false])
  const [toggleWhereWhen, setToggleWhereWhen] = useState(false)
  const [toggleRsvp, setToggleRsvp] = useState(false)
  const [error, setError] = useState<any>('')
  const opts: YouTubeProps['opts'] = {
    height: '390',
    width: '640',
    playerVars: {
      autoplay: 1,
    },
  }
  const onPlayerReady: YouTubeProps['onReady'] = (event: any) => {
    event.target.pauseVideo()
  }
  const [header, setHeader] = useState({
    name: 'header',
    logo: '',
    logoName: '',
    campaignMessage: '',
    media: '',
    mediaName: '',
    youtubeLink: '',
  })

  const [quote, setQuote] = useState<any>({
    name: 'quote',
    data: [
      {
        content: '',
        backgroundImage: '',
        backgroundImageName: '',
      },
    ],
  })
  const [bulletPoints, setBulletpoints] = useState<any>({
    name: 'bulletPoints',
    data: [
      {
        content: '',
        backgroundImage: '',
      },
    ],
  })

  const [whereWhen, setWhereWhen] = useState<any>({
    name: 'whereWhen',
    eventTitle: '',
    eventDescription: '',
    address: '',
    start: null,
    end: null,
  })
  const [rsvp, setRsvp] = useState({
    name: 'rsvp',
    email: '',
    title: '',
    option: [''],
  })
  const googleCalander = () => {
    let estart = whereWhen?.start !== null ? whereWhen.start?.toISOString() : whereWhen?.start
    let eEnd = whereWhen.end !== null ? whereWhen.end?.toISOString() : whereWhen.end
    const data = {
      start: estart,
      end: eEnd,
      title: header.campaignMessage,
      location: whereWhen.address,
      description: whereWhen.eventDescription,
    }
    window.open(
      `https://calendar.google.com/calendar/u/0/r/eventedit?text=${
        data.title
      }&dates=${data.start.replaceAll('-', '')}/${data.end.replaceAll('-', '')}&details=${
        data.description
      }&location=${data.location}`
    )
  }

  const downloadIcal = () => {
    const data = {
      start: whereWhen.start.toISOString(),
      end: whereWhen.end.toISOString(),
      title: header.campaignMessage,
      location: whereWhen.address,
      description: whereWhen.eventDescription,
    }

    createEvent(data, (error: any, value: any) => {
      const blob = new Blob([value], {type: 'text/plain;charset=utf-8'})

      saveAs(blob, 'event-schedule.ics')
    })
  }

  const data = {
    header: {
      name: 'header',
      logo: 'https://cellcast-templates.s3.ap-southeast-2.amazonaws.com/usanews.png',
      logoName: 'usanews.png',
      campaignMessage: 'Campaign key messa',
      media:
        'https://cellcast-templates.s3.ap-southeast-2.amazonaws.com/da583146273d9113330707a12dcd119a.png',
      mediaName: 'da583146273d9113330707a12dcd119a.png',
      youtubeLink: '',
    },
    quote: {
      data: [],
    },
    bulletPoints: {
      data: [],
    },
    whereWhen: {
      name: 'whereWhen',
      eventTitle: 'Event Title',
      eventDescription: 'Event description',
      address: 'Address',
      start: '2023-03-13T18:30:00.000Z',
      end: '2023-03-21T18:30:00.000Z',
    },
    rsvp: {
      option: ['dfdsfsdfdsf'],
      name: 'rsvp',
      email: 'hello@gmail.com',
      title: 'Please enter valid email',
    },
    rsvpButtons: false,
    _id: '64116fb0c412a31532709414',
    user: '63a41adfee804cd21a648ab9',
    createdAt: '2023-03-15T07:11:44.690Z',
    updatedAt: '2023-03-30T12:08:12.072Z',
    __v: 0,
  }

  useEffect(() => {
    let code = param.pathname?.split('/').at(-1)
    dispatch(getLandingPageData({url: code}))
  }, [])

  useEffect(() => {
    if (landingpageDetail) {
      let arr = Object.values(landingpageDetail)

      arr?.map((key: any) => {
        if (key?.name == 'header') {
          if (key?.campaignMessage !== '' || key?.media !== '' || key?.logo !== '') {
            setHeader(key)

            setToggleHeader(true)
            key?.media == '' ? setMedia('youtube') : setMedia('media')
          }
        }
        if (key?.name == 'quote') {
          setQuote(key)

          setToggleQuote(Array(key?.data?.length).fill(true))
        }
        if (key?.name == 'bulletPoints') {
          setBulletpoints(key)

          setToggleBulletPoint(Array(key?.data?.length).fill(true))
        }
        if (key?.name == 'rsvp') {
          let optionData = key?.option?.map((key: any, index: any) => {
            let keyLabel = `option${index + 1}`
            return key[keyLabel]
          })
          setOptionData(key?.option)
          setRsvp({...key, option: optionData})
          setToggleRsvp(true)
        }
        if (key?.name == 'whereWhen') {
          setToggleWhereWhen(true)
          setWhereWhen({
            ...key,
            start: new Date(key?.start?.replaceAll('/', '-')),
            end: new Date(key?.end?.replaceAll('/', '-')),
          })
        }
      })
    }
    //   if (param?.state?.rsvpButtons) {
    //     setRsvpButton(param?.state?.rsvpButtons)
    //   }
  }, [landingpageDetail])

  const handleClick = () => {
    let code = param.pathname?.split('/').at(-1)
    dispatch(
      responseLandingPageData({
        url: code,
        response: {
          response: formValues,
        },
      })
    ).then(() => {
      setIsSuccess(true)
    })
  }

  if (isSuccess) {
    return <SuccessMessagePage />
  }

  return (
    <>
      {landingpageDetail ? (
        <div className='inner-content-main LandingDetailPage'>
          <>
            {header !== undefined && (
              <>
                <div>
                  <>
                    {header?.logo !== null && header?.logo !== '' && (
                      <>
                        {' '}
                        {typeof header?.logo !== 'object' ? (
                          <img
                            className='logo d-block ms-auto me-auto'
                            style={{marginTop: '20px'}}
                            src={header?.logo}
                            alt='poster'
                          />
                        ) : (
                          <img
                            className='logo d-block ms-auto me-auto'
                            style={{marginTop: '20px'}}
                            src={URL.createObjectURL(header?.logo)}
                            alt='poster'
                          />
                        )}
                      </>
                    )}
                  </>
                  <h1 className='d-flex justify-content-center landingPageHeading'>
                    {header?.campaignMessage}
                  </h1>

                  {header?.media !== '' && header?.media !== null && (
                    <>
                      {typeof header?.media !== 'object' ? (
                        <img
                          className='col-12 hero_media'
                          style={{marginTop: '20px'}}
                          src={header?.media}
                          alt='poster'
                        />
                      ) : (
                        <img
                          className='col-12 hero_media'
                          style={{marginTop: '20px'}}
                          src={URL.createObjectURL(header?.media)}
                          alt='poster'
                        />
                      )}
                    </>
                  )}

                  {header?.youtubeLink !== '' && (
                    <div className='youtubeWrapper d-flex'>
                      <YouTube
                        id='youtubeDiv'
                        videoId={header?.youtubeLink?.split('=')?.at(-1)}
                        opts={opts}
                        onReady={onPlayerReady}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
            {quote !== undefined && (
              <>
                {quote?.data?.map((key: any, i: number) => {
                  return (
                    <React.Fragment key={i}>
                      {typeof key?.backgroundImage == 'string' ? (
                        <div
                          className='LandingPageContent d-flex justify-content-center align-items-center flex-column my-5'
                          style={{
                            backgroundImage: `url(${key?.backgroundImage})`,
                          }}
                        >
                          <div dangerouslySetInnerHTML={{__html: key?.content}} />
                        </div>
                      ) : (
                        <>
                          {key?.backgroundImage !== null && (
                            <div
                              className='position-relative z-10000 LandingPageContent d-flex justify-content-center align-items-center flex-column my-5'
                              style={{
                                backgroundImage: `url(${URL.createObjectURL(
                                  key?.backgroundImage
                                )})`,
                              }}
                            >
                              <div dangerouslySetInnerHTML={{__html: key?.content}} />
                            </div>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  )
                })}
              </>
            )}

            <div className='container py-10'>
              <div className='DesOut'>
                {bulletPoints !== undefined && (
                  <>
                    <div className='LandingPageDescription'>
                      {bulletPoints?.data?.map((key: any, i: number) => {
                        return <div key={i} dangerouslySetInnerHTML={{__html: key?.content}} />
                      })}
                    </div>
                  </>
                )}

                {optionData?.length > 0 && (
                  <div className='d-flex flex-column w-70 mb-3'>
                    <h4>{rsvp?.title}</h4>
                    {optionData?.map((key: any, index: number) => {
                      return (
                        <div className='landingpage_inside_label gap-2 d-flex' key={index}>
                          <input
                            value={Object.keys(key).at(0)}
                            type='radio'
                            checked={formValues.includes(Object?.keys(key)?.at(0))}
                            onChange={(e: any) => {
                              setFormValues([e.target.value])
                              // Change to handle survey
                              // let check = formValues.indexOf(e.target.value)
                              // if (check >= 0) {
                              //   let data = [...formValues]
                              //   data.splice(check, 1)
                              // setFormValues(data)
                              // } else {
                              //   setFormValues([...formValues, e.target.value])
                              // }
                            }}
                          />
                          <label>{Object.values(key).at(0)}</label>
                        </div>
                      )
                    })}
                  </div>
                )}

                <div className='text-center mb-7'>
                  {moment(whereWhen?.start).isValid() && (
                    <>
                      <h4 className='fw-bold mb-4'>When -</h4>
                      <p className='mb-2'>
                        {moment(whereWhen?.start)?.format('dddd, MMMM Do [at] h:mm A')} and
                      </p>
                      <p>
                        {moment(whereWhen?.end)?.format('dddd, MMMM Do [at] h:mm A')}
                      </p>
                    </>
                  )}

                  {whereWhen?.address && (
                    <>
                      <h4 className='fw-bold mb-4'>Where -</h4>
                      <p className='mb-2'>{whereWhen?.address}</p>
                    </>
                  )}
                </div>
              </div>
            </div>

            {moment(whereWhen?.start).isValid() ? (
              <div className='evenrSectionOuter'>
                <div>
                  <div className='eventHead'>
                    <h3>Don't miss this event!</h3>
                    <p>Add it to your calendar so you don't miss out.</p>
                  </div>
                  <ul className='text-center eventSection row'>
                    <li className='col-md-6 col-lg-4'>
                      <div className='icon'>
                        <img src={toAbsoluteUrl('/media/misc/outlook.png')} alt='img' />
                      </div>
                      <div onClick={downloadIcal} className='btn btn-primary mb-2 outlook'>
                        Outlook Calender
                      </div>
                    </li>
                    <li className='col-md-6 col-lg-4'>
                      <div className='icon'>
                        <img src={toAbsoluteUrl('/media/misc/google.png')} alt='img' />
                      </div>
                      <div onClick={googleCalander} className='btn btn-primary mb-2 calendar'>
                        Google Calender
                      </div>
                    </li>
                    <li className='col-md-6 col-lg-4'>
                      <div className='icon'>
                        <img src={toAbsoluteUrl('/media/misc/ical.png')} alt='img' />
                      </div>
                      <div onClick={downloadIcal} className='btn btn-primary mb-2 ical'>
                        ical
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <div className='mt-10'></div>
            )}

            <div className='submit_section'>
              <button
                disabled={formValues?.length <= 0}
                onClick={handleClick}
                type='submit'
                className='btn btn-light-primary btn-md'
              >
                Submit
              </button>
            </div>
          </>
        </div>
      ) : (
        <SuccessMessagePage />
      )}
    </>
  )
}

export default LandingPage
